import { useTranslation } from "react-i18next";
import LegalLayout from "./LegalLayout";
import { getLegalDoc } from "./legalContent";

export default function Privacy() {
  const { i18n } = useTranslation();
  const doc = getLegalDoc("privacy", i18n.language);
  return <LegalLayout title={doc.title} updatedAt={doc.updatedAt} blocks={doc.blocks} />;
}
